import Axios from "api/axios"
import { history } from "app-history"
import { store } from 'redux/storeConfig/store'
import { platformVpFetchAssessmentContext } from 'redux/actions/platform/vp'

export const getAssessmentContext = async (data) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/assessment',
      data
    })
    return result.data
  } catch (error) {
    history.push('/404')
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const putAssessmentVerify = async (data) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/assessment/verify',
      data
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const putAssessmentEndorse = async (data) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/assessment/endorse',
      data
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const putAssessmentSubmit = async (data) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/assessment/submit',
      data
    })
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const putAssessmentUpdateApply = async (data) => {
  const { platform: { vp: { assessmentContext: { name, email, companyReferral, userRefereeReferral } } } } = store.getState()

  try {
    await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/auth/registereasy',
      data: {
        name,
        email,
        userRefereeReferral,
      }
    })
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }

  try {
    await Axios({
      withCredentials: true,
      method: 'POST',
      url: '/apply',
      data: companyReferral
    })
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
  
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/assessment/apply',
      data
    })
    store.dispatch(platformVpFetchAssessmentContext(data))
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}

export const putAssessmentRecommendation = async (data) => {
  try {
    const result = await Axios({
      withCredentials: true,
      method: 'PUT',
      url: '/assessment/recommend',
      data
    })
    store.dispatch(platformVpFetchAssessmentContext(data))
    return result.data
  } catch (error) {
    if (typeof error.response === 'undefined') return { message: 'Server is offline, please contact admin' }
    else return error.response.data
  }
}
